/* SilvaStone NE header: Shopify-driven menu, accessible mobile navigation. */
(() => {
  if (customElements.get('silva-header')) return;
  class SilvaHeader extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector('[data-sshd-open]');
      this.closeButton = this.querySelector('[data-sshd-close]');
      this.backdrop = this.querySelector('[data-sshd-dismiss]');
      this.panel = this.querySelector('[data-sshd-panel]');
      this.isOpen = false;
      this.onKeydown = (event) => {
        if (event.key === 'Escape') {
          if (this.isOpen) { event.preventDefault(); this.closeDrawer(); }
          this.querySelectorAll('[data-desktop-dropdown][open]').forEach(item => item.removeAttribute('open'));
        }
        if (event.key === 'Tab' && this.isOpen) {
          const focusables = [...this.panel.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex="0"]')].filter(el => el.getClientRects().length);
          if (!focusables.length) return;
          const first = focusables[0], last = focusables[focusables.length-1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      };
      this.onDocumentClick = event => {
        if (!this.contains(event.target)) this.querySelectorAll('[data-desktop-dropdown][open]').forEach(item => item.removeAttribute('open'));
      };
      this.onScroll = () => { this.classList.toggle('is-scrolled', window.scrollY > 55); };
      this.onResize = () => { if (window.innerWidth >= 1200 && this.isOpen) this.closeDrawer(); };
      this.onOpen = () => this.showDrawer();
      this.onClose = () => this.closeDrawer();
      this.openButton?.addEventListener('click',this.onOpen);
      this.closeButton?.addEventListener('click',this.onClose);
      this.backdrop?.addEventListener('click',this.onClose);
      document.addEventListener('keydown',this.onKeydown);
      document.addEventListener('click',this.onDocumentClick);
      window.addEventListener('scroll',this.onScroll,{passive:true});
      window.addEventListener('resize',this.onResize,{passive:true});
      this.onScroll();
      this.querySelectorAll('[data-desktop-dropdown]').forEach(item => {
        item.addEventListener('mouseenter', () => {
          if (window.matchMedia('(min-width: 1200px) and (hover: hover)').matches) item.open = true;
        });
        item.addEventListener('mouseleave', () => {
          if (window.matchMedia('(min-width: 1200px) and (hover: hover)').matches) item.open = false;
        });
        item.addEventListener('toggle',() => {
          if (item.open) this.querySelectorAll('[data-desktop-dropdown]').forEach(other => { if(other !== item) other.open=false; });
        });
      });
      this.querySelectorAll('.sshd__drawer-nav a, .sshd__drawer-foot a').forEach(link => link.addEventListener('click', () => this.closeDrawer()));
    }
    disconnectedCallback() {
      this.openButton?.removeEventListener('click',this.onOpen);
      this.closeButton?.removeEventListener('click',this.onClose);
      this.backdrop?.removeEventListener('click',this.onClose);
      document.removeEventListener('keydown',this.onKeydown);
      document.removeEventListener('click',this.onDocumentClick);
      window.removeEventListener('scroll',this.onScroll);
      window.removeEventListener('resize',this.onResize);
      document.body.classList.remove('sshd-drawer-open');
    }
    showDrawer() {
      if (!this.panel) return;
      this.isOpen = true;
      this.panel.inert = false;
      this.panel.setAttribute('aria-hidden','false');
      this.classList.add('is-menu-open');
      document.body.classList.add('sshd-drawer-open');
      this.openButton?.setAttribute('aria-expanded','true');
      this.closeButton?.focus();
    }
    closeDrawer() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-menu-open');
      document.body.classList.remove('sshd-drawer-open');
      this.openButton?.setAttribute('aria-expanded','false');
      this.openButton?.focus();
      this.panel.inert = true;
      this.panel.setAttribute('aria-hidden','true');
    }
  }
  customElements.define('silva-header',SilvaHeader);
})();
